import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiCustomMetrics {
  static createCustomMetric(customMetric) {
    return apiFetch(`${ApiBaseUrl}custom_metrics`, {
      method: "POST",
      body: { custom_metric: customMetric },
    });
  }

  static getCustomMetrics() {
    return apiFetch(`${ApiBaseUrl}custom_metrics`);
  }

  static updateCustomMetric(customMetric) {
    return apiFetch(`${ApiBaseUrl}custom_metrics/${customMetric.id}`, {
      method: "PUT",
      body: { custom_metric: customMetric },
    });
  }

  static deleteCustomMetric(customMetric) {
    return apiFetch(`${ApiBaseUrl}custom_metrics/${customMetric.id}`, {
      method: "DELETE",
    }).then(_ => customMetric.id);
  }
}
